import * as React from 'react';
import { View, TouchableOpacity, Text, Image, StyleSheet } from 'react-native';
import * as Handlers from './handle';
import * as Constants from './constant';
import { Icon } from '@qnpm/q-theme';
import { scale } from '@qnpm/q-theme/dist/responsive';
import { qAccessibilityLabel } from '@qnpm/q-design-utils';
const kActiveOpacity = 0.7;
export class CheckBox extends React.Component {
    render() {
        const { type = 'grayEmpty' } = this.props;
        if (type === 'line' || type === 'side') {
            return this.renderLabelTypeComponent();
        }
        return this.renderBaseTypeComponent(type);
    }
    /**
     * 基础类型复选框
     */
    renderBaseTypeComponent(type) {
        const { onPress, disable = false, selected = false, needScale = false, accessibilityPreName = '' } = this.props;
        const activeOpacity = disable ? 1 : kActiveOpacity;
        const marginStyle = Handlers.getCheckBoxMargin(this.props.customStyle, needScale);
        const style = Handlers.getCheckBoxColorStyle(this.props);
        return (<TouchableOpacity {...qAccessibilityLabel(`${accessibilityPreName}qdCheckBox#${selected}#${disable}`)} hitSlop={{ left: 10, right: 10, top: 10, bottom: 10 }} activeOpacity={activeOpacity} onPress={() => {
            onPress && onPress(disable ? false : selected);
        }} style={[style.wrapper, marginStyle]}>
                {this.renderImgIcon(type)}
            </TouchableOpacity>);
    }
    /**
     * 图片类型icon
     */
    renderImgIcon(type) {
        const style = Handlers.getCheckBoxColorStyle(this.props);
        const { disable = false, selected = false } = this.props;
        // 状态图标url，默认选中
        let url = Constants.ICON_IMG.selected;
        if (disable) {
            url = Constants.ICON_IMG.unavailable;
        }
        else if (selected) {
            url = Constants.ICON_IMG.selected;
        }
        else {
            // 状态为未选择时，图片展示取决于复选框类型（type)
            url = Constants.ICON_IMG[type];
        }
        return (<Image style={[style.icon, styles.iconImg]} source={{ uri: url }}/>);
    }
    /**
     * 标签类型复选框
     */
    renderLabelTypeComponent() {
        const { customStyle, onPress, selected = false, needScale = false, accessibilityPreName = '', disable = false } = this.props;
        const comStyles = Handlers.getCheckBoxColorStyle(this.props);
        const marginStyle = Handlers.getCheckBoxMargin(customStyle, needScale);
        const borderStyle = Handlers.getCheckBoxBorderStyle(this.props);
        const iconStyle = Handlers.getCheckBoxLableIconStyle();
        return (<TouchableOpacity accessible={false} {...qAccessibilityLabel(`${accessibilityPreName}qdCheckBox#${selected}`)} activeOpacity={disable ? 1 : kActiveOpacity} style={[comStyles.wrapper, marginStyle, borderStyle]} onPress={() => {
            onPress && onPress(disable ? false : selected);
        }}>
                <View style={styles.labelContentWrapper}>
                    <View style={Handlers.getLabelContentPadding(this.props)}>
                        {this.renderLabelContent(this.props)}
                    </View>
                    <View style={comStyles.icon}>
                        <Icon name="checked" size={iconStyle.fontSize} color={iconStyle.color} style={iconStyle.style} needScale={needScale}/>
                    </View>
                </View>
            </TouchableOpacity>);
    }
    /**
     * 标签类型展示内容
     * @param props 组件属性
     */
    renderLabelContent(props) {
        const { text = '', renderLabelNode, needScale = false } = props;
        if (renderLabelNode) {
            // 优先展示自定义内容
            return renderLabelNode();
        }
        const comStyles = Handlers.getCheckBoxColorStyle(this.props);
        return (<Text style={[comStyles.text, { fontSize: scale(14, needScale) }]} numberOfLines={1}>
                {text}
            </Text>);
    }
}
const styles = StyleSheet.create({
    labelContentWrapper: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        width: '100%',
        height: '100%',
        backgroundColor: 'transparent'
    },
    iconImg: {
        width: '100%',
        height: '100%'
    }
});
